<template>
  <div class="blog-art-page">

    <div
      :class="$store.state.isMobile?'content mb-0':' mb-3 content-desktop'"
    >
      <div class="breadcrumb m-2"> 
        <router-link class="back" :to="{name:'blog'}">Blog </router-link>
        <span class="current text-truncate">{{ data?.title }}</span>
      </div>
    
      <pre-loader v-if="loading"/>
      <div v-else-if="data" class="blog-item geoff-bg-section rounded-3 p-3">
        <div class="item-title"> {{data.title}}</div>
        <div class="item-date"> {{formatDate}}</div>
        <div v-html="data.htmlContent"></div>
      </div>
      <div v-else class="blog-item geoff-bg-section rounded-3 p-3">
        Page not found
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment'
import PreLoader from "@/components/UI/PreLoader";
export default {
  name: "BlogArticleView",
  components: {PreLoader, },
  data:()=>{
    return{
      loading: true,
      data: null
    }
  },
  computed: {
    formatDate() {
      return moment(this.data?.articleDate).format('DD/MM/YYYY')
    }
  },
  mounted(){
    this.load()
  },
  methods:{
    load(){
      this.loading = true
      this.API.getBlogPage(this.$route.params.page)
      .then(data=>{
        this.data = data
      })
      .catch(err=>{
        console.log(err);

      })
      .finally(() => this.loading = false)
    }
  }
}
</script>

<style scoped>
  .content{
    margin-top: 3.5rem;
    margin-bottom: 3.5rem;
    overflow-x: hidden;
    overflow-y: scroll;
    position: fixed;
    top: calc(0px + env(safe-area-inset-top));
    bottom: calc(3.5rem + env(safe-area-inset-bottom));
    right: 0;
    left: 0;
  }
  .content-desktop {
    width: 100%;
    overflow: hidden;
  }
  .blog-art-page {

    .breadcrumb  {
      display: flex;
      gap: 0.5rem;
      flex-wrap: nowrap;
      font-size: 1.125rem;
      font-weight: 700;
      color: var(--geoff-txt-main);
        .back {
          color: var(--geoff-txt-main);
          text-decoration: none;
          white-space: nowrap;
          &::after {
            content: "❯";
            margin-left: 0.3rem;
          }
        }
        .current {}
    }

    .blog-item {
      line-height: 1.1;

      .item-title {
        font-size: 1.5rem;
        font-weight: 600;
        color: var(--geoff-txt-main);
        margin-bottom: 0.5rem;
      }
 
      .item-date {
        font-size:  0.875rem;
        color: var(--geoff-txt-note);
        margin-bottom: 0.5rem;
      }
      
    }
  }

</style>